import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})

export class AuthService {

  private _loginUrl = environment.hotelConfig.apiUrl + '/admin/login';

  constructor(private http: HttpClient, private _router: Router) { }


  loginUser(user) {
    return this.http.post<any>(this._loginUrl, user);
  }

  logoutUser() {
    localStorage.removeItem('Auth_Key');
  }

  getToken() {
    return localStorage.getItem('Auth_Key');
  }

  loggedIn() {
    return localStorage.getItem('Auth_Key');
  }
}
